/* eslint-disable func-names */
import 'slick-carousel';
import $ from 'jquery';


// Landing service carousel
$(document).ready(() => {
  // Mobile carousel settings
  $('.service-carousel').slick({
    mobileFirst: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    variableWidth: true,
    centerMode: true,
  });

  // Tablet and Desktop carousel settings
  $('.service-carousel-tablet').slick({
    mobileFirst: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    variableWidth: true,
    centerMode: true,
  });


  function handleSpotlightServiceColor(slide) {
    switch (slide) {
      case 0:
        $('.spotlight').addClass('blue');
        $('.spotlight').removeClass('red purple');
        $('.title .rich-text b').addClass('blue');
        $('.title .rich-text b').removeClass('red purple');
        break;
      case 1:
        $('.spotlight').addClass('purple');
        $('.spotlight').removeClass('red blue');
        $('.title .rich-text b').addClass('purple');
        $('.title .rich-text b').removeClass('red blue');
        break;
      case 2:
        $('.spotlight').addClass('red');
        $('.spotlight').removeClass('blue purple');
        $('.title .rich-text b').addClass('red');
        $('.title .rich-text b').removeClass('blue purple');
        break;
      default:
        break;
    }
  }

  // Mobile
  // Add card animation after carousel swipe
  $('.service-carousel').on('afterChange', (event, slick, currentSlide) => {
    $('.link', this).removeClass('animation-service-card');
    $(`.link[data-slide='${currentSlide}']`).addClass('animation-service-card');
    handleSpotlightServiceColor(currentSlide);
  });
  // Default first card
  $(`.link[data-slide='${0}']`).addClass('animation-service-card');


  // Tablet and Desktop
  // Custom goto
  $('.goto[data-slide]').click(function (e) {
    e.preventDefault();
    const slidenToGo = $(this).data('slide');
    $('.service-carousel-tablet').slick('slickGoTo', slidenToGo);
  });
  // Default first custom goto
  $(`.goto[data-slide='${0}']`).toggleClass('hovered');

  // Handle hovered state when slick change
  $('.service-carousel-tablet').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    $(`.goto[data-slide='${currentSlide}']`).toggleClass('hovered');
    $(`.goto[data-slide='${nextSlide}']`).toggleClass('hovered');
    handleSpotlightServiceColor(nextSlide);
  });

  // Goto hover
  $('.goto').hover(function () {
    $('.topic', this).toggleClass('active');
  });
});
